import gql from 'graphql-tag';

export const GET_REGION_BY_ID = gql`
  query getRegion($id: ID!) {
    region(id: $id) {
        kitInformation
    }
  }
`;